import React, { useEffect, useState } from 'react'
import { GetDocs } from '../../../firebase/utils'



export const UserCustomer=({Nom})=>{
  return (
    <div style={{display:'flex',flexDirection:'column', gap:'1rem', alignItems:'center',justifyContent:'center'}}>

      <div style={{width:'10rem',height:'10rem',borderRadius:'10rem',backgroundColor:'#3d3d3d',display:'flex',alignItems:'center',justifyContent:'center'}}>
        <img src={''} alt="" style={{width:'100%'}}/>
      </div>
      
      <div style={{backgroundColor:'#fff',padding:'0.5rem 2rem',color:'#000',fontWeight:'900',borderRadius:'2rem'}}>{Nom}</div>
    </div>
  )
}


const Customers = () => {

    const [Customers,setCustomers]=useState(null)
  
    useEffect(() => {
      GetDocs("Customers").then((result)=>setCustomers(result)) 
    }, [])
    
  return (
    
    <div className='FadeIn' style={{display:'flex',flexWrap:'wrap',gap:'2rem',alignContent:'flex-start'}}>
      {Customers===null? "...Loading" : Customers.map((Customer,id)=>{ return ( <UserCustomer key={id} Nom={Customer.Nom}/>) })}
    </div>
  )
}

export default Customers